import React, { useState, useEffect, ReactNode } from 'react';
import { store, persistor } from 'careand-redux/store';
import LoadingScreen from 'components/Utils/LoadingScreen';
import { useAppDispatch } from '../../careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';

export default function ViewAsGate({ children }: { children: ReactNode }) {
  const dispatch = useAppDispatch();
  const [ready, setReady] = useState(
    () => !new URLSearchParams(window.location.search).has('viewAs'),
  );

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('viewAs');
    if (!code) return;

    // Clean URL immediately so the code doesn't live on in browser history.
    window.history.replaceState({}, '', window.location.pathname);

    dispatch(api.Authentication.exchangeViewAs({ viewAsCodeExchange: { code } }))
      .then(() => {
        // Prevent the impersonation token from leaking into IndexedDB.
        if (store.getState().authentication.readOnly) {
          persistor.pause();
        }
      })
      .catch((e: unknown) => console.error('ViewAs exchange failed', e))
      .finally(() => setReady(true));
  }, []);

  if (!ready) return <LoadingScreen />;
  return <>{children}</>;
}
